// Shared pricing data for the tabbed pricing section used on the
// Home page, /trademark-registration (Trademark Register service page),
// and /lp landing page.
//
// tmSignUpType: 1 = Self Filing with Assistance
// tmSignUpType: 2 = IP Attorney-Led Filing

export const introSection = {
  heading: "Brand Protection Made Simple",
  description:
    "Trademark Facility helps businesses secure their identity through reliable filing, monitoring, renewals, and complete trademark support. Whether your goal is to protect a company name, claim ownership of a logo, or safeguard a slogan, our team makes the process clear and manageable. We assist brands across all 50 U.S. states and international markets, helping keep your intellectual property protected wherever your business operates.",
};

export const pricingTabs = [
  { id: 1, label: "Self Filing with Assistance" },
  { id: 2, label: "IP Attorney-Led Filing" },
];

export const processCardsByTab = {
  1: [
    {
      title: "Application Preparation",
      description: "Trademark Facility reviews your filing information, identifies the correct trademark class, and prepares your application for submission through the USPTO TEAS system.",
      icon: "FileText",
    },
    {
      title: "Identity Review and Approval",
      description: "You complete ID.me verification, then check the attorney-prepared application in detail. Any required edits or changes can be requested before submission.",
      icon: "CheckCircle",
    },
    {
      title: "USPTO Filing",
      description: "After approval, Trademark Facility submits your application to the USPTO, ensuring every detail is accurate, complete, and ready for official review.",
      icon: "UploadSimple",
    },
  ],
  2: [
    {
      title: "Information Collection",
      description: "We collect your trademark details, including name, logo (if applicable), and a brief description of your products/services.",
      icon: "ClipboardText",
    },
    {
      title: "Attorney Review & Application Drafting",
      description: "Our IP attorney reviews your case, determines the appropriate trademark class(es), and prepares a strong, USPTO-compliant application.",
      icon: "Scales",
    },
    {
      title: "Filing & Case Management",
      description: "We file the application on your behalf and handle all procedural steps, including monitoring your application and managing any USPTO correspondence.",
      icon: "Briefcase",
    },
  ],
};

export const pricingHeaderByTab = {
  1: {
    title: "Self-Filing with Expert Assistance",
    subtitle: "Complete Support Plan for Easy Filing",
  },
  2: {
    title: "Attorney-Led Filing",
    subtitle: "Complete End-to-End Service Plan",
  },
};

export const pricingPackagesByTab = {
  1: [
    {
      name: "BASIC",
      price: "$45",
      // period: "+ USPTO Fee",
      description: "Simple guided process with expert support at every step to ensure accuracy",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Search",
        "State E-Filing",
        "Trademark Secured",
      ],
      paymentNotice: "Govt. filing fee not included",
    },
    {
      name: "STANDARD",
      price: "$149",
      // period: "+ USPTO Fee",
      description: "Balanced assistance that helps you move forward with clear professional direction",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Trademark Search",
        "State + Federal E-Filing",
        "Trademark Alert (Basic)",
        "Digital File Access",
        "Case Status Updates",
        "Trademark Secured"
      ],
      popular: true,
      paymentNotice: "Govt. filing fee not included",
    },
    {
      name: "DELUXE",
      price: "$395",
      // period: "+ USPTO Fee",
      description: "Advanced support with deeper planning, careful review, and ongoing clarity",
      features: [
        "Case Review",
        "Case Filing",
        "Advanced Direct Hit Search",
        "Federal & State Comprehensive Search Report",
        "Trademark Alert System",
        "Trademark Monitoring (Basic)",
        "Refusal Risk Check (Basic Level)",
        "Digital File + Documentation",
        "Dedicated Support (Email/Chat)",
        "Trademark Secured",
        "24 Hrs. Expedited Service"
      ],
      paymentNotice: "Govt. filing fee not included",
    },
    {
      name: "PLATINUM",
      price: "$595",
      // period: "+ USPTO Fee",
      description: "Premium guided service with expert attention, leadership, and complete confidence",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "100% Satisfaction Guarantee",
        "Refusal Risk Assessment",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager",
        "100% Approval Guarantee",
        "Comprehensive Trademark Search Report (Federal & State)",
        "24 Hrs. Expedited Service",
        "Cease & Desist Letter"
      ],
      paymentNotice: "Govt. filing fee not included",
    },
  ],
  2: [
    {
      name: "BASIC",
      price: "$795",
      // period: "+ USPTO Fee",
      description: "Reliable professional support for a smoother and more confident filing process",
      features: [
        "Attorney-Handled Trademark Filing from Start to Finish",
        "Professional Case Evaluation",
        "Application Preparation & Submission",
        "Preliminary Trademark Search",
        "State-Level E-Filing Included",
        "Attorney-Handled Trademark Filing from Start to Finish",
        "Professional Case Evaluation",
        "Application Preparation & Submission",
        "Preliminary Trademark Search",
        "State-Level E-Filing Included"
      ],
      paymentNotice: "Govt. filing fee not included",
    },
    {
      name: "STANDARD",
      price: "$895",
      // period: "+ USPTO Fee",
      description: "Guided step-by-step assistance with added care, clarity, and peace of mind",
      features: [
        "Attorney-Led Trademark Filing",
        "End-to-End Case Handling",
        "Comprehensive Case Review & Analysis",
        "Professional Application Preparation",
        "Trademark Secured",
        "USPTO-Compliant Filing Process",
        "Attorney-Led Trademark Filing",
        "End-to-End Case Handling",
        "Comprehensive Case Review & Analysis"
      ],
      popular: true,
      paymentNotice: "Govt. filing fee not included",
    },
    {
      name: "DELUXE",
      price: "$1,145",
      // period: "+ USPTO Fee",
      description: "Organized service with expert review, careful preparation, and steady progress",
      features: [
        "Attorney-Led Case Review",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Trademark Monitoring & Alerts",
        "Comprehensive Risk & Refusal Meter",
        "Attorney-Led Case Review",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Trademark Monitoring & Alerts",
        "Comprehensive Risk & Refusal Meter"
      ],
      paymentNotice: "Govt. filing fee not included",
    },
    {
      name: "PLATINUM",
      price: "$1,545",
      // period: "+ USPTO Fee",
      description: "Priority support with focused attention, quicker handling, and greater confidence",
      features: [
        "Attorney-Led Case Review & Strategy",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Federal & State Trademark Search Report",
        "Trademark Monitoring & Real-Time Alerts",
        "Attorney-Led Case Review & Strategy",
        "Complete Case Filing & Management",
        "Advanced Direct-Hit Trademark Search",
        "Federal & State Trademark Search Report",
        "Trademark Monitoring & Real-Time Alerts"
      ],
      paymentNotice: "Government filing fee included",
    },
  ],
  
};
